module.exports = __webpack_public_path__ + "img/localization-pointer.54db5e6c.svg";